import { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import closeIcon from './close.png'
import './SharedImagePage.css'
import SetBackgroundButton from '../search/SetBackgroundButton'
import { proxyPexelsImageUrl } from '../util/pexels'

const MAX_INVITER_SCREEN_NAME_LENGTH = 80

function sanitizeInviterScreenName(value) {
  if (typeof value !== 'string') return ''

  return Array.from(value)
    .filter((character) => {
      const characterCode = character.charCodeAt(0)
      return characterCode >= 32 && characterCode !== 127
    })
    .join('')
    .trim()
    .slice(0, MAX_INVITER_SCREEN_NAME_LENGTH)
}

function SharedImagePage() {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const [imageLoaded, setImageLoaded] = useState(false)
  const imageId = searchParams.get('image_id')
  const imageMediumUrl = searchParams.get('image_medium_url')
  const imageLandscapeUrl = searchParams.get('image_landscape_url')
  const imageAlt = searchParams.get('image_alt') || searchParams.get('alt')
  const inviterScreenName = sanitizeInviterScreenName(
    searchParams.get('inviter_screen_name')
  )
  const isInviterAnonymous = !inviterScreenName
  const inviteText = isInviterAnonymous
    ? 'The following virtual background has been shared with you:'
    : `${inviterScreenName} shared a background with you:`

  const sharedImage = {
    id: imageId,
    alt: imageAlt,
    src: {
      landscape: proxyPexelsImageUrl(imageLandscapeUrl),
      medium: proxyPexelsImageUrl(imageMediumUrl),
    },
  }

  const history = useHistory()
  const navigateHome = useCallback(() => history.push('/'), [history])
  const handleImageLoad = () => {
    // When the image is loaded, set imageLoaded to true and fade in using opacity
    setImageLoaded(true)
  }

  if (!sharedImage.id) {
    navigateHome()
    return null
  }

  return (
    <div>
      <button className="close-button" onClick={navigateHome}>
        <img src={closeIcon} alt="close button" />
      </button>

      <p className="shared-image-title">{inviteText}</p>

      <div
        className={`shared-image-container ${imageLoaded ? 'loaded' : ''}`}
        aria-label={`sharedImage`}
      >
        <img
          alt={sharedImage.alt}
          className="shared-image"
          src={sharedImage.src.medium}
          onLoad={handleImageLoad}
        />
      </div>

      <div className={`button-container ${imageLoaded ? 'loaded' : ''}`}>
        <SetBackgroundButton image={sharedImage} />
      </div>
    </div>
  )
}

export default SharedImagePage
